<mat-list-item *ngIf="practice$ | ngrxPush as practice">
  <mat-icon matListItemIcon>room</mat-icon>
  <span matListItemTitle>{{ practice.name }}</span>
  <span matListItemLine>Chair / Room</span>
</mat-list-item>
